const moduleKey = 'USER_MODULE';

export const userTypes = {
  LOAD_REQUESTED: moduleKey + "_LOAD_REQUESTED",
  LOADED: moduleKey + "_LOADED",
  SET_TABLE_CONFIG: moduleKey + "_SET_TABLE_CONFIG",
  SET_TABLE_CONFIG_FILTER: moduleKey + "_SET_TABLE_CONFIG_FILTER",
  CHANGE_TAB: moduleKey + '_CHANGE_TAB',
  CLOSE_TAB: moduleKey + '_CLOSE_TAB',
  CREATE_TAB: moduleKey + '_CREATE_TAB',
  GET_DETAIL_REQUESTED: moduleKey + '_GET_DETAIL_REQUESTED',
  GET_DETAIL_LOADED: moduleKey + '_GET_DETAIL_LOADED',
  VERIFY_ACCOUNT: moduleKey + '_VERIFY_ACCOUNT'
};

export const userActions = {
  loadRequested: (tableConfig) => ({ type: userTypes.LOAD_REQUESTED, tableConfig }),
  loaded: (data) => ({ type: userTypes.LOADED, payload: { data } }),
  setTableConfig: (key, value) => ({ type: userTypes.SET_TABLE_CONFIG, key, value }),
  setTableConfigFilter: (key, value) => ({ type: userTypes.SET_TABLE_CONFIG_FILTER, key, value }),
  changeTab: (key) => ({ type: userTypes.CHANGE_TAB, key }),
  closeTab: (key) => ({ type: userTypes.CLOSE_TAB, key }),
  createTab: (key, title) => ({ type: userTypes.CREATE_TAB, key, title }),
  getDetail: (id, index) => ({ type: userTypes.GET_DETAIL_REQUESTED, id, index }),
  getDetailLoaded: (data, index) => ({ type: userTypes.GET_DETAIL_LOADED, payload: { data }, index }),
  verifyAccount: (token) => ({ type: userTypes.VERIFY_ACCOUNT, token }),
};
